import { forwardRef, Ref, type SVGProps } from 'react';

const SvgUpdatesIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 23 27"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.858 0C6.204 0 0 5.744 0 12.83V25h9.657C17.026 25 23 19.469 23 12.645V0zM8.112 17.646v-9.79l8.222 4.394z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUpdatesIcon);
export default ForwardRef;
